import type { operations } from '@/api'
import { post } from './client'

export type SkipFieldPath =
  `/api/workspaces/${string}/projects/${string}/entities/${string}/properties/${string}/skip`
export type SkipFieldRequest = Exclude<
  operations['entity-skip-field']['requestBody'],
  undefined
>['content']['application/json']

export type SkipFieldResponse =
  operations['entity-skip-field']['responses']['200']['content']['application/json']

/**
 * Skips a field by marking it as skipped. This can only be used on fields that are in the 'idle' state.
 */
export const skipField = (
  workspaceId: string,
  projectId: string,
  entityId: string,
  propertyId: string,
) =>
  post<SkipFieldRequest, SkipFieldResponse, SkipFieldPath>(
    `/api/workspaces/${workspaceId}/projects/${projectId}/entities/${entityId}/properties/${propertyId}/skip`,
    {},
  )
